module.exports = {
  sanitize: function(canvas, content, elem) {
    var svgcontent = content.firstChild;
    var clipPath = elem.getAttribute('clip-path');
    var tool = INKIVE.Tool.getInstance();
    var itNeedsClipPath = !$(elem).is('.logo')
      && !$(elem).parent().is('.logo')
      && !$(elem).is('.icon')
      && !$(elem).parent().is('.icon')
      && !$(elem).parent().is('.video');

    var $clipPath = $(content).find(tool.editor.canvas.getClipPathId(clipPath));
    var hasMissingClipPath = !clipPath || $clipPath.length === 0;

    itNeedsClipPath && hasMissingClipPath && this.addMissingClipPath(canvas, svgcontent, elem);
    if ($clipPath.length) {
      this.removeElementWithInvalidClipPath($clipPath, elem);
    }
  },

  addMissingClipPath: function(canvas, svgcontent, elem) {
    var newClipPathId = 'clip_' + elem.id;
    var layoutBox = this.getLayoutBox(canvas, svgcontent, elem);
    var layoutDefs = this.getlayoutDefs(svgcontent);
    var layoutDefsClip = window.document.createElementNS(svgedit.NS.SVG, 'clipPath');

    this.purgeExistingClipPath(svgcontent, newClipPathId);

    elem.setAttribute('clip-path', 'url("#' + newClipPathId + '")');
    $(elem).addClass('layoutBox').removeClass('image');

    layoutBox.setAttribute('class', 'layoutClipper');
    layoutDefsClip.setAttribute('id', newClipPathId);
    layoutDefsClip.appendChild(layoutBox);

    layoutDefs.appendChild(layoutDefsClip);
    svgcontent.insertBefore(layoutDefs, svgcontent.firstChild);
  },

  getLayoutBox: function(canvas, svgcontent, elem) {
    var bb = getBackupBB() || getImageBB();

    setBackupBB(bb);

    return canvas.addSvgElementFromJson({
      element: 'rect',
      curStyles: false,
      attr: _.extend(bb, {id: INKIVE.Helpers.getUnusedId(svgcontent)})
    });

    function setBackupBB(bb) {
      elem.textContent = bb.x + ' ' + bb.y + ' ' + bb.width + ' ' + bb.height;
    }

    function getBackupBB() {
      var dimensions = elem.textContent.split(/[^-|\d\.]/);

      return dimensions && dimensions.length === 4 && {
        x: Math.floor4(dimensions[0]),
        y: Math.floor4(dimensions[1]),
        width: Math.floor4(dimensions[2]),
        height: Math.floor4(dimensions[3])
      };
    }

    function getImageBB() {
      return {
        x: elem.getAttribute('x'),
        y: elem.getAttribute('y'),
        width: elem.getAttribute('width'),
        height: elem.getAttribute('height')
      };
    }
  },

  getlayoutDefs: function(svgcontent) {
    var layoutDefs = $(svgcontent).find('defs').get(0);

    if (!layoutDefs) {
      layoutDefs = window.document.createElementNS(svgedit.NS.SVG, 'defs');
      layoutDefs.setAttribute('id', 'layout_defs');
    }

    return layoutDefs;
  },

  purgeExistingClipPath: function(svgcontent, newClipPathId) {
    var $existingClipPath = $(svgcontent).find('#' + newClipPathId);
    $existingClipPath[0] && $existingClipPath.remove();
  },

  removeElementWithInvalidClipPath: function($clipPath, elem) {
    var isInvalid = false;

    $clipPath.find('[width],[height]').each(function() {
      if ($(this).attr('width') <= 0 || $(this).attr('height') <= 0) {
        isInvalid = true;
      }
    });

    if (isInvalid) {
      $clipPath.remove();
      $(elem).remove();
    }
  },

  removeUnusedClippaths: function(content) {
    var $content = $(content);

    $content.find('.main').siblings('defs').children().each(function() {
      $content.find('[clip-path="url(#' + this.id + ')"]').length || $(this).is('clip-path') && $(this).remove();
    });
  }
};
